function initSandroProductDialogs() {
  const sandroDialogs = document.querySelectorAll("dialog[data-sandro-modal]");
  
  sandroDialogs.forEach(dialog => {
    const showBtn = dialog.previousElementSibling;
    const closeBtn = dialog.querySelector(".sandro-product-modal__closeBtn");

    showBtn.addEventListener("click", () => {
      dialog.showModal();
    });

    closeBtn.addEventListener("click", () => {
      dialog.close();
    });

    const prevModalBtn = dialog.querySelector('button.sandro-product-modal__prev') || null;
    const nextModalBtn = dialog.querySelector('button.sandro-product-modal__next') || null;
    
    
    
    const modalHistory = (arr, button) => {
        const index = [...arr].findIndex(element => element.getAttribute('data-sandro-modal') === button.getAttribute('data-sandro-modal'));
        if (index < 0) {
            button.setAttribute('hidden', true)
        } else {
            button.querySelector('span').textContent = arr[index].getAttribute('data-sandro-modal-title')
        }
        return index;
    }

    const isPrevModal = modalHistory(sandroDialogs, prevModalBtn);
    const isNextModal = modalHistory(sandroDialogs, nextModalBtn);
    
    prevModalBtn.addEventListener("click", () => {
      if (isPrevModal >= 0) {
        sandroDialogs[isPrevModal].showModal();
        dialog.close();
      }

    });

    nextModalBtn.addEventListener("click", () => {
      if (isNextModal >= 0) {
        sandroDialogs[isNextModal].showModal();
        dialog.close();
      }

    });

  });
}

initSandroProductDialogs()
